// test2218
(2218 && 0);
